<template>
  <span class="zfkanban-active">
    <div class="titl">{{title||'低碳智慧能源运营管理平台'}}</div>
    <div class="box">
      <span v-for="(e,i) in list" :key="i">
        <div class="box_li" v-if="e.weizhi" :style="{'top':e.top,'left':e.left}">
          <div class="left">
            <div class="t" @click="urlTo(e.url)" :style="{'background':e.color}">{{e.tit}}</div>
            <div class="ul" v-if="e.li1 ||e.li2 ||e.li3">
              <div class="li" v-if="e.li1"> <i></i>{{e.li1}}</div>
              <div class="li" v-if="e.li2"> <i></i>{{e.li2}}</div>
              <div class="li" v-if="e.li3"> <i></i>{{e.li3}}</div>
            </div>
          </div>
          <img src="./img/x.png" alt="">
        </div>
        <div class="box_li" v-else :style="{'top':e.top,'left':e.left}">
          <img src="./img/x.png" style="transform: rotateY(180deg);">
          <div class="left">
            <div class="t" @click="urlTo(e.url)" :style="{'background':e.color}">{{e.tit}}</div>
            <div class="ul" v-if="e.li1 ||e.li2 ||e.li3">
              <div class="li" v-if="e.li1"> <i></i>{{e.li1}}</div>
              <div class="li" v-if="e.li2"> <i></i>{{e.li2}}</div>
              <div class="li" v-if="e.li3"> <i></i>{{e.li3}}</div>
            </div>
          </div>
        </div>
      </span>

      <span v-for="(e,i) in list_text" :key="i">
        <div class="box_li box_li2" :style="{'top':e.top,'left':e.left}">
          <div class="tt" :style="{'color':e.color}">{{e.tit}}</div>
        </div>
      </span>
    </div>
  </span>

</template>

<script>
  export default {
    data() {
      return {
        title: getName2(),
        dataList: [],
        list: getDataList2(),
        list_text: getDataList2_text(),
      };
    },
    mounted() {
    },
    methods: {
      urlTo(c) {
        if (c == 'pingtaiTemp' || c == "pingtai") {
          this.$router.push(c)
        } else {
          window.open(c, '_blank');
        }

      },
    },

  };
</script>
<style lang="scss" scoped>
  .box_li2 .tt {
    font-size: 15px;
    color: #000;
    font-weight: bold;
  }
  .zfkanban-active {
    position: fixed;
    top: 0;
    left: 0;
    background-color: #cccfd8 !important;
    background: url('./img/bg.png');
    background-size: 100% 100%;
    margin-top: 0px !important;
    height: 100% !important;
    z-index: 1;
    color: #fff;

    .box_li {
      position: absolute;
      display: flex;

      img {
        width: 87px;
        height: 89px;
        object-fit: contain;
      }

      .ul {
        width: fit-content; 
        border-radius: 4px;
        /* 自动布局 */
        display: none;
        flex-direction: column;
        box-sizing: border-box;
        padding: 12px;
        padding-right: 26px;
        gap: 12px;
        background: rgba(0, 0, 0, 0.15);
        backdrop-filter: blur(12px);
        margin-top: 4px;
        max-width: 250px;

        .li {
          font-family: Microsoft YaHei;
          font-size: 16px;
          font-variation-settings: "opsz" auto;
          display: flex;
          align-items: center;

          i {
            display: none;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #FFF;
            margin-right: 8px;
          }
        }
      }

      .left {
        transform: translateY(-17px);

        .t:hover {
          color: #3670f7;
          cursor: pointer;
          +.ul{
            display: flex !important;
          }
        }

        .t {

          border-radius: 4px;
          /* 自动布局 */
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 8px 9px;
          background: #E27D10;
          font-family: Microsoft YaHei;
          font-size: 18px;
          font-weight: bold;
        }
      }
    }

  
    .titl {
      position: absolute;
      left: 0px;
      top: 0px;
      width: 100%;
      height: 72px;
      text-align: center;
      line-height: 72px;
      font-family: Microsoft YaHei;
      font-size: 36px;
      font-weight: bold;
      text-shadow: 0 4px 1px #444, 0 2px 0 #222;
      /* 阴影效果 */

      /* 向上移动文字 */
      color: #FFFFFF;
      letter-spacing: 3px;
      background: none;
    }

    .box {
      display: flex;
      width: 100%;
      justify-content: center;
      margin-top: 100px;


    }
  }
</style>